import Vue from 'vue';
import moment from 'moment-timezone';
import { guid } from '@/mixins/guid';
import dropsLoader from '@/mixins/components/drops-loader';

export default Vue.component('close-ticket', {
  template: require('./template.html'),
  name: 'close-ticket',
  mixins: [guid],
  components: {
    dropsLoader,
  },
  data() {
    return {
      loading: false,
      sendErrors: false,
    };
  },
  props: ['toggle-modal', 'modal', 'ticket'],
  methods: {
    async closeTicket() {
      this.loading = true;
      this.sendErrors = false;
      try {
        const timestamp = moment(moment.utc().format())._i;
        await this.$lightning([{
          name: 'closeSupportTicket',
          payload: {
            ticketId: this.ticket._id,
            timestamp,
          },
        }]);
        this.$store.dispatch('setGlobalValue', {
          item: this.ticket,
          key: 'status',
          value: 'closed',
        });
        this.closeModal('closeTicket');
        this.$store.dispatch('addNotification', {
          id: this.guid(),
          type: 'success',
          message: 'Successfully closed ticket.',
        });
      } catch (e) {
        this.$log.error(e.message || e);
        this.sendErrors = `${e.message || e}. This has been reported.`;
        await this._reportError({
          error: e,
          fn: 'closeTicket',
        });
      } finally {
        this.loading = false;
      }
    },
    closeModal(type) {
      this.$emit('toggle-modal', type, 'child');
    },
    formatErrors(arr) {
      return arr.join(' ');
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/support/tickets/view/close-ticket/index.js